export default __webpack_public_path__ + "static/media/learn-hand-wash.79cde2a1.png";